import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Chip } from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LayoutContext } from "../../contexts/LayoutContext.jsx"

function SideNavItem({ navItem,customeclass,isSingle }) {
  const { setShowSideNav } = useContext(LayoutContext)
  const navigate = useNavigate()
  const handleClickNav = () => {
    navigate(navItem.url,)
   // window.open(navItem.url, "_blank");
    setShowSideNav(false)
  }
  
  return (
    <li className={`${isSingle?"treeli":""}`}>
      <Chip
      size="sm"
      radius="none"
       variant="light"
       // to= { navItem.url}
       
        onClick={handleClickNav}
        startContent={navItem && navItem?.icon && <FontAwesomeIcon className={`${navItem?.color ?navItem?.color:'text-white'} 
        ${customeclass && customeclass!=''?"":"border-1 border-dotted border-gray-400 bg-grayuy-200   rounded-md"}
         text-xs p-1  mr-1`}  icon={navItem?.icon} />}
      // startContent={navItem && navItem?.icon && <FontAwesomeIcon icon={faArrowRightLong  } />}
        className={ ` w-full flex justify-start  shadow-sm bg4-white  text-xs  cursor-pointer
         ${customeclass?customeclass:
          ' text-white uppercase  hover:bg-gradient-to-r from-white to-white hover:text-red-700'} `}
        //  bg-custom-nav-bg-color  text-custom-nav-text-color hover:bg-custom-bg-light hover:text-sky-700
      >
        {navItem.name}
      </Chip>
    </li>
  )
}

export default SideNavItem
